/**
 * iter_226 · Phase 22 — Buyer's Singles Library
 */
import { useEffect, useState } from "react";
import api, { BACKEND_URL } from "@/lib/api";
import { optimizeImage } from "@/lib/mediaUrls";

const MySinglesLibrary = () => {
  const [items, setItems] = useState(null);
  useEffect(() => {
    (async () => {
      try {
        const r = await api.get("/singles/me/library");
        setItems(r.data.items || []);
      } catch { setItems([]); }
    })();
  }, []);
  if (items === null) return <div className="p-8 text-xs text-gray-500">Loading…</div>;
  const tok = typeof window !== "undefined" ? localStorage.getItem("session_token") || "" : "";
  return (
    <div className="max-w-4xl mx-auto p-4 space-y-4" data-testid="my-singles-library">
      <h1 className="text-2xl font-black text-white">My Singles</h1>
      {items.length === 0 && <p className="text-xs text-gray-500 py-8 text-center">Nothing purchased yet.</p>}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        {items.map((s) => (
          <div key={s.purchase_id} className="rounded-xl border border-white/10 bg-black/40 p-3 flex gap-3" data-testid={`library-item-${s.listing_id}`}>
            {s.cover_url && <img src={optimizeImage(s.cover_url, 'avatar')} alt="" className="w-20 h-20 rounded object-cover" />}
            <div className="min-w-0 flex-1">
              <p className="text-sm font-bold text-white truncate">{s.title}</p>
              <p className="text-[11px] text-gray-400 truncate">{s.primary_artist_name}</p>
              {s.revoked ? (
                <p className="text-[10px] text-rose-300 mt-2">Access revoked.</p>
              ) : (
                <a
                  href={`${BACKEND_URL}/api/singles/${s.listing_id}/download-file?token=${encodeURIComponent(tok)}`}
                  className="mt-2 inline-block text-[11px] px-2 py-1 rounded bg-emerald-500 text-black font-black hover:bg-emerald-400"
                  data-testid={`library-download-${s.listing_id}`}
                >
                  ⬇ Download MP3
                </a>
              )}
              <p className="text-[9px] text-gray-500 mt-1">Downloads: {s.download_count}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MySinglesLibrary;
